import React from 'react';
import { DataGrid } from '@mui/x-data-grid';
import {Box, Grid, Button} from '@material-ui/core';
import {TextField, FormControl, Stack, Snackbar, Alert, LinearProgress, Radio, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';
import SaveIcon from '@mui/icons-material/Save';
import {MetaTags} from 'react-meta-tags';
import axios from 'axios';
import Cookies from 'js-cookie';
import Tooltip from '@mui/material/Tooltip';
import ChannelSave from './ChannelSave';
import DialogAuthorization from '../components/DialogAuthorization';
import { useSelector } from 'react-redux';
import * as env from '../utils/EnvVars';
import Header from "../pages/HeaderMy";
///import moment from 'moment';
import '../styles/bizofficer-a.css';
import 'font-awesome/css/font-awesome.min.css';

  
  var vertical='top',horizontal='center';
  
  export default function Execute() {
	const userObj = useSelector(state => state.userDetails);	
	const isloggedin = Cookies.get('isBlogAdminLoggedIn');
	const childRefNewSave = React.useRef();
	const childRefAuthorization = React.useRef();
	const [pageLoading, setPageLoading] = React.useState(true);
	const [deleteDialogShow, setDeleteDialogShow] = React.useState(false);
	const [filter, setFilter] = React.useState(false);
	const [keyword, setKeyword] = React.useState("");
	const [dataObj, setDataObj] = React.useState({});
	const [rows, setRows] = React.useState([]);
	const [selectedRow, setSelectedRow] = React.useState(0);
	const [authPrivileges, setAuthPrivileges] = React.useState({});
	
	const [delBtn, setDelBtn] = React.useState(false);
	const [severityAlert, setSeverityAlert] = React.useState("error");
	const [showAlert, setShowAlert] = React.useState(false);
	const [alertMessage, setAlertMessage] = React.useState("");
  

	var myCurrentDate=new Date();
	var myPastFromDate=new Date(myCurrentDate);
    myPastFromDate.setDate(myPastFromDate.getDate() - 366);

	function hideAlert(){
		setShowAlert(false);
	}

	const columns = [
		{
			field: "Select",
			headerName: "",
			width: 90,
			sortable: false,
				renderCell: (cellValues) => {
				return (
				  <Radio 
					checked={cellValues.id === selectedRow}
					value={cellValues.id}
					name="radio-buttons"
					inputProps={{ 'aria-label': {cellValues} }}
				  />
				 )
			  }
		  },
		{ field: 'id', headerName: 'Sr. No.', width: 40 },
		{ field: 'channelName', headerName: 'Channel Name', flex: 1, renderCell: (params) =>  (
			<Tooltip title={params.value} ><span>{params.value}</span></Tooltip>
		   ), },
		{ field: 'url', headerName: 'URL', flex: 1} ,
		{ field: 'modifiedBy', headerName: 'Modified By', flex: 1, renderCell: (obj) =>  (
			<span>{obj.row.modifiedBy} {obj.row.modifiedDateTime}</span>
		   ), },
	    { field: 'createdBy', headerName: 'Created By', flex: 1, renderCell: (obj) =>  (
			<span>{obj.row.createdBy} {obj.row.createdDateTime}</span>
		   ), } ,
   
	  ];
	

	// check if logged in
	React.useEffect(() => {
		if(!isloggedin){
			window.location.href='login';
		}
	}, [isloggedin]);

	React.useEffect(() => {		
		if(userObj?.obj && userObj?.obj?.loginId && userObj?.obj?.token){
			getApiData(userObj?.obj?.loginId, userObj?.obj?.token, keyword);
		}
	}, [userObj,filter]);

	async function getApiData(loginId,token,keyword){
		let axiosHeader = {
			headers:{
			  'Content-Type': 'multipart/mixed',
			  'loginId': loginId,
			  'token': token,
			  'device': 'web'
			}
		  }; 
			axios.get(env.API_URL+'/admin/channel-list?keyword='+keyword, axiosHeader)
			   .then(response => {
			 	////document.write("Just Checking >> "+JSON.stringify(response.data)); 
				 setPageLoading(false);
				 if(response.data && response.data.responseTxt==="InvalidToken"){ 
					Cookies.remove('isBlogAdminLoggedIn');
					window.location.href='login';
				 }else if(response.data && response.data.responseTxt==="NoAuthorization"){ 
					 childRefAuthorization.current.handleClickOpen();
				 }else if(response.data.responseTxt==="success"){
					if(response.data?.obj){					 
					  setRows(response.data.obj);
					}  
					  setAuthPrivileges(response.data.privileges);
				 }	 				
			})
	}

	function deleteData(){
		if(dataObj && userObj?.obj && userObj?.obj?.loginId && userObj?.obj?.token){
			let axiosHeader = {
				headers:{
				  'Content-Type': 'multipart/mixed',
				  'loginId': userObj?.obj?.loginId,
				  'token': userObj?.obj?.token,
				  'device': 'web'
				}
			  }; 
	
		  const data = new FormData();
		  data.append('id', dataObj.autoId);
		
		  setDelBtn(true);
		  axios.post(env.API_URL+'/admin/channel-delete', data, axiosHeader)
				.then((response) => {
					setDelBtn(false);
					///console.log("RESPONSE RECEIVED: ", response.data.responseTxt);
				if(response.data.responseTxt==="success"){
					setSeverityAlert("success");
					setShowAlert(true);
					setAlertMessage("Channel has been deleted.");
			  		reload();	
					deleteDialogHide();
					return false;
				}else{
			  		setSeverityAlert("error");
					setShowAlert(true);
					setAlertMessage("This channel could not be deleted.");			
					return false;
				}
			})
				.catch((error) => {
					console.log("AXIOS ERROR: ", error);
				})	
		}		
	
		
	}

	function saveData(opt){
		if(opt===1){
			setDataObj(null);
		}	
		childRefNewSave.current.handleClickOpen();
	}

	function selectRow(obj){
		if(obj && rows[obj.id-1]){			
			setSelectedRow(rows[obj.id-1].id);
			setDataObj(rows[obj.id-1]);
			///childRef.current.handleClickOpen();
		}
	}

	function search(){
		setFilter(!filter);
	}

	function onEnter(event){
		if(event.key === 'Enter'){
			search();
		}
	}
	
	function deleteDialogHide(){
		setDeleteDialogShow(false);
	}

	function reload(){
		setSelectedRow(0);
		setDataObj({});
		search();
	}
	

	return (
		<div> 
				<MetaTags>
            		<title>Channels</title>
          		</MetaTags>
				
				<Header title="Channels" />
				{pageLoading?<LinearProgress />:null}

				<Box className='mainBox'>	

					<Box mt={1}>
							<Grid container spacing={2}>
								<Grid item md={12} xs={12}>

									<FormControl style={{float:'left',width:150,marginRight:60}}>
										<TextField
										id="keywordtxt"
										label="Search"
										defaultValue={keyword}
										sx={{ width: 200 }}
										size="small"
										onChange={event => setKeyword(event.target.value)}
										onKeyPress={(event)=>{onEnter(event)}}
										/>
									</FormControl>

									<Button onClick={() => {search()}} style={{marginTop: -3}} size="small" variant="contained" color="secondary" >Search</Button>

									<span style={{marginTop:30}}>
											{(authPrivileges && authPrivileges.create===1)?	
												<i onClick={()=>{saveData(1)}} title="Add New" className="fa fa-plus-circle" style={{fontSize:25, color:'#0158dc',marginLeft:15, cursor:'pointer'}} />
											:null}
										{selectedRow>0?<>
											{(authPrivileges && authPrivileges.update===1)?
												<i onClick={()=>{saveData(2)}} title="Edit" className="fa fa-pencil-square-o" style={{fontSize:25, color:'#0158dc',marginLeft:15, cursor:'pointer'}} />
											:null}
											{(authPrivileges && authPrivileges.delete===1)?
												<i onClick={()=>{setDeleteDialogShow(true)}} title="Delete" className="fa fa-trash" style={{fontSize:25, color:'#0158dc',marginLeft:15, cursor:'pointer'}} />
											:null}	
										</>:null}
									</span>	
								</Grid>
							</Grid>
					</Box>

					<div className="tblReport" style={{height: '82vh', width: '100%' }}>
						<DataGrid
							rows={rows}
							columns={columns}
							pageSize={50}
							rowHeight={40}
							rowsPerPageOptions={[50]}
							ActionsComponent={()=>{alert('Hello')}}		
							style={{fontSize:12}}
							components={{
								NoRowsOverlay: () => (
								  <Stack height="100%" alignItems="center" justifyContent="center">
									<span style={{color:'#FF0000',fontWeight:'bold'}}>No rows found!</span>
								  </Stack>
								)}}	
							onRowClick={itm => selectRow(itm)}	
						/>
					</div>

				</Box>

			<ChannelSave dataObj={dataObj} reload={reload} ref={childRefNewSave} />						
			
			<Stack spacing={2} sx={{ width: '100%' }}>
					<Snackbar open={showAlert} autoHideDuration={6000} onClose={hideAlert} anchorOrigin={{vertical,horizontal}}  >
						<Alert onClose={hideAlert} variant="filled" severity={severityAlert} sx={{ width: '100%' }}>
							{alertMessage}
						</Alert>
					</Snackbar>
			</Stack>

				<Dialog
					open={deleteDialogShow}
					onClose={deleteDialogHide}
					aria-labelledby="alert-dialog-section-title"
					aria-describedby="alert-dialog-section-description"
				>
					<DialogTitle id="alert-dialog-section-title">
						Alert
					</DialogTitle>
					<DialogContent>
					<DialogContentText id="alert-dialog-section-description">
						Are you sure, You want to delete.
					</DialogContentText>
					</DialogContent>
					<DialogActions>
					<Button variant="outlined" size="small" onClick={()=>{deleteDialogHide()}}>Don't Delete</Button>
					{delBtn?                
						<LoadingButton loading loadingPosition="start" startIcon={<SaveIcon />} style={{backgroundColor:'#ff0000',color:'#FFF',marginRight:10}} size="small" variant="outlined" >Deleting...</LoadingButton>
						:<Button variant="contained" size="small" color="secondary" onClick={()=>{deleteData()}} autoFocus>Yes, Delete</Button>
                    }
					</DialogActions>
				</Dialog>

			    <DialogAuthorization ref={childRefAuthorization} />

		</div>	
	);
  }